import affirm from '../core/Affirm'
import Helper from './Helper'

class DevSettingsClass {
    get = () => {
        affirm(Helper.isDev(), 'Trying to get dev settings while not in a dev environment')

        try {
            const local = require('../local.json')
            return local
        } catch {
            console.log('No local.json found, proceding with default configuration.')
            return null
        }
    }

    /**
     * Searches for a key inside local.json which is available only in dev
     */
    getValue = (key: string) => {
        const settings = this.get()
        if (settings) return settings[key]
        else return null
    }
}

const DevSettings = new DevSettingsClass()
export default DevSettings
